var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExtendVotingDeadline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#DFDEFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 9C11.4625 9 11.25 9.2125 11.25 9.46875V12.4C11.25 12.6187 11.3625 12.8187 11.5438 12.9313L13.8187 14.3313C13.9199 14.3926 14.0412 14.4112 14.1561 14.3831C14.2709 14.355 14.3699 14.2824 14.4313 14.1813C14.4926 14.0801 14.5112 13.9588 14.4831 13.8439C14.455 13.7291 14.3824 13.6301 14.2813 13.5688L12.1875 12.3125V9.46875C12.1875 9.2125 11.975 9 11.7188 9Z",
    fill: "#4749B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9151 11.5C16.5388 11.5 16.254 11.8364 16.2487 12.2127C16.2433 12.5996 16.1863 12.9852 16.0782 13.3591C15.9038 13.9627 15.6006 14.5213 15.1896 14.9965C14.7785 15.4717 14.2694 15.8522 13.6972 16.1118C13.125 16.3713 12.5033 16.5038 11.875 16.5C9.4375 16.5 7.5 14.5625 7.5 12.125C7.5 9.6875 9.4375 7.75 11.875 7.75C12.0296 7.75 12.1819 7.75781 12.3315 7.77314C12.733 7.81428 13.125 7.52455 13.125 7.12095C13.125 6.84141 12.9329 6.59508 12.6562 6.55545C12.4015 6.51897 12.1406 6.5 11.875 6.5C8.75 6.5 6.25 9 6.25 12.125C6.25 15.25 8.75 17.75 11.875 17.75C12.6673 17.7533 13.4513 17.5885 14.1752 17.2664C14.8991 16.9444 15.5465 16.4724 16.0745 15.8818C16.6026 15.2911 16.9994 14.5951 17.2386 13.8398C17.4226 13.2588 17.5103 12.6529 17.4992 12.0459C17.4935 11.7339 17.2272 11.5 16.9151 11.5Z",
    fill: "#4749B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.125H17.5V5.875C17.5 5.53125 17.2188 5.25 16.875 5.25C16.5312 5.25 16.25 5.53125 16.25 5.875V7.125H15C14.6562 7.125 14.375 7.40625 14.375 7.75C14.375 8.09375 14.6562 8.375 15 8.375H16.25V9.625C16.25 9.96875 16.5312 10.25 16.875 10.25C17.2188 10.25 17.5 9.96875 17.5 9.625V8.375H18.75C19.0938 8.375 19.375 8.09375 19.375 7.75C19.375 7.40625 19.0938 7.125 18.75 7.125Z",
    fill: "#4749B2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExtendVotingDeadline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/extend_voting_deadline.d52cb2d5.svg";
export { ForwardRef as ReactComponent };